import { getRoute } from "@utils/route";

export const THANK_YOU_BETA_PAGE_URL = '/thank-you-beta';

export const routeThankYouBetaPage = () => getRoute(THANK_YOU_BETA_PAGE_URL);
